// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__jscC9"};